var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid grid--gap-0" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("rb-loading", { attrs: { loading: _vm.submitted } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.submitted,
                expression: "!submitted",
              },
            ],
            staticClass: "rb-login-overlay rb-login rb-login_register",
          },
          [
            _c("p", { staticClass: "rb-login-overlay__title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.translation("private_sale.registerTitle")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.errorAgeContent
              ? _c("div", [
                  _c("div", { staticClass: "error-age-message" }, [
                    _c("h5", { staticClass: "error-age-message__head" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.translation("private_sale.facebookErrorHead")
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "error-age-message__body" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.translation("private_sale.facebookErrorBody")
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.lastStepContent
              ? _c("div", [
                  _c("div", { staticClass: "last-step-message" }, [
                    _c("h5", { staticClass: "last-step-message__head" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.translation(
                              "private_sale.facebookFinalStepRegHead"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "last-step-message__body" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.translation(
                              "private_sale.facebookFinalStepRegBody"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isFacebookShow
              ? _c("p", { staticClass: "rb-login-overlay__paragraph" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.translation("private_sale.registrationOnesMessage")
                      ) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.error && _vm.errorMessage
              ? _c("div", [
                  _c("p", { staticClass: "rb-login-overlay__error" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.errorMessage) + "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isSocialLoginEnabled
              ? [
                  _vm.isFacebookShow
                    ? _c("rb-facebook-login", {
                        ref: "btnFb",
                        attrs: {
                          "is-frame-advisor": _vm.isFrameAdvisor,
                          "section-login": "private_sale_register",
                        },
                        on: {
                          eventFacebookRegister: _vm.updateFieldsFromFbRegister,
                        },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.isFacebookShow
              ? _c(
                  "p",
                  { staticClass: "rb-login-overlay__paragraph_subtitle" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation(
                            "private_sale.facebookOrAccountRegister"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                staticStyle: { "margin-top": "0px" },
                attrs: { name: "emailForm", novalidate: "novalidate" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  },
                },
              },
              [
                _c("rb-textfield", {
                  staticClass: "rb-login-overlay__firstName",
                  attrs: {
                    id: "firstName",
                    name: "firstName",
                    type: "text",
                    required: "true",
                    label: _vm.labelFormatter(
                      _vm.translation("private_sale.firstNameLabel")
                    ),
                    error: _vm.translation("private_sale.firstNameError"),
                    validation: _vm.$v.firstName,
                  },
                }),
                _vm._v(" "),
                _c("rb-textfield", {
                  staticClass: "rb-login-overlay__lastName",
                  attrs: {
                    id: "lastName",
                    name: "lastName",
                    type: "text",
                    required: "true",
                    label: _vm.labelFormatter(
                      _vm.translation("private_sale.lastNameLabel")
                    ),
                    error: _vm.translation("private_sale.lastNameError"),
                    validation: _vm.$v.lastName,
                  },
                }),
                _vm._v(" "),
                _c("rb-textfield", {
                  staticClass: "rb-login-overlay__emailAddress",
                  attrs: {
                    id: "emailAddress",
                    name: "emailAddress",
                    type: "email",
                    required: "true",
                    label: _vm.translation("private_sale.emailAddressLabel"),
                    error: _vm.translation("private_sale.emailAddressError"),
                    validation: _vm.$v.emailAddress,
                  },
                }),
                _vm._v(" "),
                _vm.isDobEnabled
                  ? _c("div", { staticClass: "grid" }, [
                      _c(
                        "div",
                        { staticClass: "col-4 rb-login-overlay__form" },
                        [
                          _c(
                            "rb-select",
                            {
                              attrs: {
                                id: "dayOfBirth",
                                name: "dayOfBirth",
                                label: _vm.translation(
                                  "private_sale.date_birth"
                                ),
                                validation: _vm.$v.dayOfBirth,
                                required: "required",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.translation("private_sale.day_birth")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.getDaysList(), function (index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: index } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(index) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4 rb-login-overlay__form" },
                        [
                          _c(
                            "rb-select",
                            {
                              attrs: {
                                id: "monthOfBirth",
                                name: "monthOfBirth",
                                validation: _vm.$v.monthOfBirth,
                                required: "required",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.translation(
                                        "private_sale.month_birth"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.getMonthsList(), function (index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: index } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(index) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4 rb-login-overlay__form" },
                        [
                          _c(
                            "rb-select",
                            {
                              attrs: {
                                id: "yearOfBirth",
                                name: "yearOfBirth",
                                validation: _vm.$v.yearOfBirth,
                                required: "required",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.translation("private_sale.year_birth")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.getYearsList(), function (index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: index } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(index) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isDobAboveCutoffAge
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col-12 rb-login-overlay__minimum-age",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.translation("private_sale.minimumAge")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isFacebookRegistration
                  ? _c("rb-textfield", {
                      staticClass: "rb-login__password",
                      attrs: {
                        id: "password",
                        name: "password",
                        type: "password",
                        required: "true",
                        label: _vm.translation("private_sale.passwordLabel"),
                        error: _vm.translation("private_sale.passwordError"),
                        validation: _vm.$v.password,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isFacebookRegistration
                  ? _c("rb-textfield", {
                      staticClass: "rb-login__passwordRepeat",
                      attrs: {
                        id: "passwordRepeat",
                        name: "passwordRepeat",
                        type: "password",
                        required: "true",
                        label: _vm.labelFormatter(
                          _vm.translation("private_sale.passwordRepeatLabel")
                        ),
                        error: _vm.translation(
                          "private_sale.passwordRepeatError"
                        ),
                        validation: _vm.$v.passwordRepeat,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEmailSignUpEnabled
                  ? _c("rb-checkbox", {
                      staticClass: "rb-login__emailSignUp",
                      attrs: {
                        id: "emailSignUp",
                        name: "emailSignUp",
                        type: "checkbox",
                        required: "true",
                        desc: _vm.getEmailSignupDescription(),
                        validation: _vm.$v.emailSignUp,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAgreeConsentEnabled
                  ? _c("rb-checkbox", {
                      staticClass: "rb-login__agreeConsent",
                      attrs: {
                        id: "agreeConsent",
                        name: "agreeConsent",
                        type: "checkbox",
                        desc: _vm.getAgreeConsentDescription(),
                        validation: _vm.$v.agreeConsent,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfilingConsentEnabled
                  ? _c("rb-checkbox", {
                      staticClass: "rb-login__profilingConsent",
                      attrs: {
                        id: "profilingConsent",
                        name: "profilingConsent",
                        type: "checkbox",
                        required: "true",
                        desc: _vm.getProfilingConsent(),
                        validation: _vm.$v.profilingConsent,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "rb-login-overlay__action-group" }, [
                  _c(
                    "button",
                    {
                      ref: "submit_register",
                      staticClass: "rb-btn rb-btn--black",
                      attrs: {
                        type: "submit",
                        "data-element-id": "X_X_PrivateSaleRegister_Register",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.translation("private_sale.register")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "rb-login__already-have-account" }, [
                    _c("span", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.translation("private_sale.alreadyHaveAccount")
                          ) +
                          "\n              "
                      ),
                      _c(
                        "button",
                        {
                          attrs: {
                            "data-element-id":
                              "X_X_PrivateSaleRegister_OpenLogin",
                          },
                          on: { click: _vm.showLoginForm },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.translation("private_sale.login")) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }